import Vue from 'vue'
export class StylesParser {
  constructor(constants, device = null) {
    this.device = device
    this.constants = constants
  }

  parse() {
    if (! this.device) {
      return this.parseStyles()
    }
    return this.parseDeviceStyles()
  }

  parseStyles() {
    let styles = new Object
    this.constants.forEach(constant => Vue.set(styles, constant.styleProperty, constant.value))
    return styles
  }

  parseDeviceStyles() {
    let styles = new Object
    this.constants[this.device].forEach(constant => Vue.set(styles, constant.styleProperty, constant.value))
    return styles
  }
}
